var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.7152 16.2998L20.7152 6.2998L22.1152 7.6998L13.5152 16.2998L22.1152 24.8998L20.7152 26.2998L10.7152 16.2998Z",
  fill: "#F2F3FD"
})));
export { SvgBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjcxNTIgMTYuMjk5OEwyMC43MTUyIDYuMjk5OEwyMi4xMTUyIDcuNjk5OEwxMy41MTUyIDE2LjI5OThMMjIuMTE1MiAyNC44OTk4TDIwLjcxNTIgMjYuMjk5OEwxMC43MTUyIDE2LjI5OThaIiBmaWxsPSIjRjJGM0ZEIi8+Cjwvc3ZnPgo=";